import { Component, forwardRef } from '@angular/core';
import { BlogsService } from 'src/app/settings/blogs/blogs.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => FacilitiesComponent)
    }
  ]
})
export class FacilitiesComponent implements ControlValueAccessor {

  cachedTags = [];
  tagsModel = [] as Array<string>;

  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  constructor(
  ) {
  }
  onAdd(item: string) {
    this._onChange(this.tagsModel);
  }

  beforeAddHandler() {
    
  }

  onRemove(item: string) {
    this._onChange(this.tagsModel);
  }

  onFocus() {
    this._onTouched(true);
  }


  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }

  writeValue(value) {
    this.tagsModel = value;
  }
}
